// import { useCallback } from "preact/hooks"
// @ts-nocheck
import { CounterWidgerProps } from '../types';

function CounterWidget(props: CounterWidgerProps) {
  const {
    incrementQty,
    decrementQty,
    updateAmount,
    value,
  } = props;

  return (
    <div class="kits__table-row-item counter-widget widget">
      <div class="kits__table-row-item-minus" onClick={decrementQty}>
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22.8059C17.5228 22.8059 22 18.3288 22 12.8059C22 7.28306 17.5228 2.80591 12 2.80591C6.47715 2.80591 2 7.28306 2 12.8059C2 18.3288 6.47715 22.8059 12 22.8059Z" stroke="#2568A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M8 12.8059H16" stroke="#2568A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="kits__table-row-item-current">
        <input type="text" name="current" value={value} onInput={(e) => updateAmount(e.target.value)} />
      </div>
      <div class="kits__table-row-item-plus" onClick={incrementQty}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#2568A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 8V16" stroke="#2568A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M8 12H16" stroke="#2568A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  )
}

export {CounterWidget};
